import { MapPin, Phone } from "lucide-react";
import { Reveal } from "./Reveal";

const BORDEAUX_IMG = "https://images.unsplash.com/photo-1493564738392-d148cfbd6eda?crop=entropy&cs=srgb&fm=jpg&q=85";

const cities = [
  "Bordeaux",
  "Villenave d'Ornon",
  "Pessac",
  "Mérignac",
  "Talence",
  "Bègles",
  "Gradignan",
  "Cenon",
  "Lormont",
  "Eysines",
  "Saint-Médard-en-Jalles",
  "Le Bouscat",
];

export const Zone = () => (
  <section id="zone" data-testid="zone-section" className="relative bg-[#070708] py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:px-10">
      <Reveal>
        <div className="relative overflow-hidden rounded-2xl border border-white/10">
          <img
            src={BORDEAUX_IMG}
            alt="Bordeaux la nuit"
            loading="lazy"
            className="aspect-[4/3] w-full object-cover opacity-80 transition-transform duration-700 hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/90 via-transparent to-transparent" />
          <div className="absolute bottom-6 left-6 right-6 flex items-center gap-3 rounded-xl border border-[#D4AF37]/30 bg-black/70 p-4 backdrop-blur">
            <MapPin className="h-6 w-6 shrink-0 text-[#D4AF37]" />
            <div>
              <p className="text-sm font-semibold text-white">Notre atelier</p>
              <p className="text-xs text-zinc-400">12 Chemin Tillon, 33140 Villenave d'Ornon</p>
            </div>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#D4AF37]">Zone d'intervention</p>
        <h2 className="mt-4 font-display text-4xl uppercase text-white sm:text-5xl lg:text-6xl">
          Bordeaux &amp; <span className="text-gold-gradient">sa métropole</span>
        </h2>
        <p className="mt-6 text-sm leading-relaxed text-zinc-400 sm:text-base">
          Nous nous déplaçons gratuitement à votre domicile, sur votre lieu de travail ou où que vous soyez dans la
          métropole bordelaise. Vous pouvez aussi venir directement à l'atelier.
        </p>
        <div className="mt-8 flex flex-wrap gap-2">
          {cities.map((c) => (
            <span
              key={c}
              data-testid={`zone-city-${c.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-medium text-zinc-300 transition-colors hover:border-[#D4AF37]/50 hover:text-[#E6CA65]"
            >
              {c}
            </span>
          ))}
        </div>
        <a
          href="tel:0602259560"
          data-testid="zone-phone-link"
          className="mt-10 inline-flex items-center gap-3 rounded-full border border-[#D4AF37]/40 px-6 py-3 text-sm font-bold uppercase tracking-widest text-[#E6CA65] transition-colors hover:bg-[#D4AF37]/10"
        >
          <Phone className="h-4 w-4" /> Vérifier ma zone : 06 02 25 95 60
        </a>
      </Reveal>
    </div>
  </section>
);
